import BudgetMenageMobilite from "./indicators/BudgetMenageMobilite";
import IngresoHogares from "./layers/IngresoHogares";

const Economy = {
    idSection: "economy",
    questionSection: "",
    treeviews: {
        title: "Mobility Indicators Content.sections.Economy",
        indicators: {
            checked: 0,
            expand: false,
        },
        layers: {
            checked: 2,
            expand: true,
        },
    },
    layers: {
        ingresoHogares: IngresoHogares,
    },
    indicators: {
        budgetMenageMobilite: BudgetMenageMobilite,
    },
};

export default Economy;
